import Orthographic, { camerasOrthographic } from './cameras.orthographic';

export { Orthographic as OrthographicCamera, camerasOrthographic as orthographicCameraFactory };
